import { useLazyLoadQuery } from 'react-relay';
import { PreConfiguredSourcesQuery } from 'src/services/DOM/queries/preconfiguredSources';
import { preconfiguredSourcesQuery } from 'src/services/DOM/queries/preconfiguredSources/__generated__/preconfiguredSourcesQuery.graphql';
import {
  UseGetPreconfiguredSourcesArgs,
  UseGetPreconfiguredSourcesReturn,
} from './model';

export const useGetPreconfiguredSources = (
  params?: UseGetPreconfiguredSourcesArgs
): UseGetPreconfiguredSourcesReturn => {
  const { fetchPolicy } = params || {
    fetchPolicy: 'store-or-network',
  };
  const { preconfiguredSources } = useLazyLoadQuery<preconfiguredSourcesQuery>(
    PreConfiguredSourcesQuery,
    {},
    { fetchPolicy }
  );

  return preconfiguredSources || [];
};
